import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const addNotificationSuccess = (msg) => {
    notification.success({
        message: msg,
    });
};

const state = () => ({
    order: {
        type: 'ROI',
        relation: {type: 'CONSUMER'},
        relationID: null,
        signatureType: 'ESIGNATURE',
        signatureData: null,
        productID: null,
        key: 0,
        extraData: {
            consumption_peak: '',
            consumption_offpeak: '',
            feedin_peak: '',
            feedin_offpeak: '',
            physical_capacity: '',
            contract_end_date: '',
            contract_type: '',
            customer_wishes: '',
            notes: '',
            number_of_solar_panels: '',
            taxable_income: '',
            usage_months: '',
            usage_hours: '',
        },
    },
    loadingCreateOrder: false,
    errorCreateOrder: false,
    loadingPreFillRelationOnOrder: false,
    errorPreFillRelationOnOrder: false,
    loadingCalculatePrice: false,
    errorCalculatePrice: false,
});

const actions = {
    async resetROIOrder({commit}) {
        await commit('resetROIOrder');
    },

    async preFillRelationOnROIOrder({commit}, data) {
        try {
            await commit('preFillRelationOnROIOrderBegin');
            await commit('addRelationToROIOrder', data.value);
            await commit('preFillRelationData', data.value);
            await commit('preFillRelationOnROIOrderSuccess');
            await data.stepRoute();
        } catch (err) {
            await commit('preFillRelationOnROIOrderErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async addRelationToROIOrder({commit}, data) {
        await commit('addRelationToROIOrder', data.value);
        await data.stepRoute();
    },

    async calculateROIPrice({commit}, data) {
        try {
            await commit('calculatePriceBegin');
            await commit('addQuestionsROIOrder', data.value);
            await commit('calculatePriceSuccess');
            await data.stepRoute();
        } catch (err) {
            await commit('calculatePriceErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async createROIOrder({commit, state}, data) {
        try {
            await commit('createROIOrderBegin');
            const orderToSubmit = data.orderData || state.order;
            const response = await DataService.post('/orders', orderToSubmit);
            await commit('createROIOrderSuccess', response.data);
            await data.successRoute();
            addNotificationSuccess('ROI rapport aanvraag is succesvol aangemaakt.');
        } catch (err) {
            await commit('createROIOrderErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async setSignatureROIData({commit}, data) {
        await commit('setSignatureROIData', data);
    },
    async setProductId({commit}, data) {
        await commit('setProductId', data);
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
